import { render, staticRenderFns } from "./CandidateTabFiles.vue?vue&type=template&id=f6755308&scoped=true&"
import script from "./CandidateTabFiles.vue?vue&type=script&lang=js&"
export * from "./CandidateTabFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6755308",
  null
  
)

export default component.exports